import { getToken } from "../../helper/common";
import agent from "../services/agent";
import {
  GET_DEVICE_DETAILS_PENDING,
  GET_DEVICE_DETAILS_SUCCESS,
  SET_DEVICE_DETAILS,
  CLOSE_EDIT_DEVICE_MODAL,
  OPEN_EDIT_DEVICE_MODAL,
  CLEAR_UPDATE_DEVICE_ERROR,
  UPDATE_DEVICE_PENDING,
  UPDATE_DEVICE_SUCCESS,
  UPDATE_DEVICE_ERROR,
  GET_MASTER_DEVICE_DETAILS_SUCCESS,
  CLOSE_EDIT_MASTER_DEVICE_MODAL,
  OPEN_EDIT_MASTER_DEVICE_MODAL,
  SET_MASTER_DEVICE_DETAILS,
  GET_MASTER_DEVICE_DETAILS_PENDING,
  UPDATE_MASTER_DEVICE_ERROR,
  UPDATE_MASTER_DEVICE_SUCCESS,
  UPDATE_MASTER_DEVICE_PENDING,
  CLEAR_UPDATE_MASTER_DEVICE_ERROR,
  CLOSE_MAP_NEW_DEVICE_MODAL,
  OPEN_MAP_NEW_DEVICE_MODAL,
  CLEAR_MAP_NEW_DEVICE_ERROR,
  MAP_NEW_DEVICE_PENDING,
  MAP_NEW_DEVICE_SUCCESS,
  MAP_NEW_DEVICE_ERROR,
  OPEN_CREATE_GROUP_MODAL,
  CLOSE_CREATE_GROUP_MODAL,
  CLEAR_CREATE_GROUP_ERROR,
  CREATE_GROUP_PENDING,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  UPDATE_ROOM_DETAILS_ERROR,
  CLOSE_UPDATE_ROOM_DETAILS_MODAL,
  OPEN_UPDATE_ROOM_DETAILS_MODAL,
  CLEAR_UPDATE_ROOM_DETAILS_ERROR,
  UPDATE_ROOM_DETAILS_PENDING,
  UPDATE_ROOM_DETAILS_SUCCESS,
  UPDATE_SELECTED_DEVICE_SWITCHLIST,
  UPDATE_SWITCH_DETAILS,
  OPEN_UPDATE_GROUP_MODAL,
  CLOSE_UPDATE_GROUP_MODAL,
  CLEAR_UPDATE_GROUP_ERROR,
  UPDATE_GROUP_PENDING,
  UPDATE_GROUP_SUCCESS,
  UPDATE_GROUP_ERROR,
  DEFAULT_MASTER_DEVICE_SERIAL_NO,
  ADD_GROUP_CREATE,
  SET_SELECTED_GROUP,
  ADD_FORM_MAP_DEVICE,
  DEVICE_DETAILS_ERROR,
  MASTER_DEVICE_DETAILS_ERROR,
  OPEN_SWITCH_DETAILS_MODAL,
  CLOSE_SWITCH_DETAILS_MODAL,
  SET_DEVICE_ID,
} from "../deviceDetails/actionTypes";
import { showSnackbarStatus } from "../snackbar/actions";
import trimmedValues from "../../helper/trimmer";
import { formatDeviceKeys } from "../device/actions";

export const getDeviceDetailsPending = () => ({
  type: GET_DEVICE_DETAILS_PENDING,
});

export const setDeviceDetails = (deviceData) => ({
  type: SET_DEVICE_DETAILS,
  payload: deviceData,
});

export const getDeviceDetailsSuccess = () => ({
  type: GET_DEVICE_DETAILS_SUCCESS,
});

export const closeEditDeviceModal = () => ({
  type: CLOSE_EDIT_DEVICE_MODAL,
});

export const openEditDeviceModal = () => ({
  type: OPEN_EDIT_DEVICE_MODAL,
});

export const clearUpdateDeviceError = () => ({
  type: CLEAR_UPDATE_DEVICE_ERROR,
});

export const updateDevicePending = () => ({
  type: UPDATE_DEVICE_PENDING,
});

export const updateDeviceSuccess = () => ({
  type: UPDATE_DEVICE_SUCCESS,
});

export const updateDeviceError = (errorMessage) => ({
  type: UPDATE_DEVICE_ERROR,
  payload: { errorMessage },
});
export const deviceDetailsError = (errorMessage) => ({
  type: DEVICE_DETAILS_ERROR,
  payload: { errorMessage },
});

export const getMasterDeviceDetailsPending = () => ({
  type: GET_MASTER_DEVICE_DETAILS_PENDING,
});

export const setMasterDeviceDetails = (organisationData) => ({
  type: SET_MASTER_DEVICE_DETAILS,
  payload: organisationData,
});

export const getMasterDeviceDetailsSuccess = () => ({
  type: GET_MASTER_DEVICE_DETAILS_SUCCESS,
});

export const closeEditMasterDeviceModal = () => ({
  type: CLOSE_EDIT_MASTER_DEVICE_MODAL,
});

export const openEditMasterDeviceModal = () => ({
  type: OPEN_EDIT_MASTER_DEVICE_MODAL,
});

export const clearUpdateMasterDeviceError = () => ({
  type: CLEAR_UPDATE_MASTER_DEVICE_ERROR,
});

export const updateMasterDevicePending = () => ({
  type: UPDATE_MASTER_DEVICE_PENDING,
});

export const updateMasterDeviceSuccess = () => ({
  type: UPDATE_MASTER_DEVICE_SUCCESS,
});

export const updateMasterDeviceError = (errorMessage) => ({
  type: UPDATE_MASTER_DEVICE_ERROR,
  payload: { errorMessage },
});

export const closeMapNewDeviceModal = () => ({
  type: CLOSE_MAP_NEW_DEVICE_MODAL,
});

export const openMapNewDeviceModal = () => ({
  type: OPEN_MAP_NEW_DEVICE_MODAL,
});

export const clearMapNewDeviceError = () => ({
  type: CLEAR_MAP_NEW_DEVICE_ERROR,
});

export const mapNewDevicePending = () => ({
  type: MAP_NEW_DEVICE_PENDING,
});

export const mapNewDeviceSuccess = () => ({
  type: MAP_NEW_DEVICE_SUCCESS,
});

export const mapNewDeviceError = (errorMessage) => ({
  type: MAP_NEW_DEVICE_ERROR,
  payload: { errorMessage },
});

export const addGroupCreate = (AddGroup) => ({
  type: ADD_GROUP_CREATE,
  payload: { AddGroup },
});

export const addFormMapDevice = (AddFormMap) => ({
  type: ADD_FORM_MAP_DEVICE,
  payload: { AddFormMap },
});

export const updateRoomDetailsError = (errorMessage) => ({
  type: UPDATE_ROOM_DETAILS_ERROR,
  payload: { errorMessage },
});

export const closeUpdateRoomDetailsModal = () => ({
  type: CLOSE_UPDATE_ROOM_DETAILS_MODAL,
});

export const openUpdateRoomDetailsModal = () => ({
  type: OPEN_UPDATE_ROOM_DETAILS_MODAL,
});

export const clearUpdateRoomDetailsError = () => ({
  type: CLEAR_UPDATE_ROOM_DETAILS_ERROR,
});

export const updateRoomDetailsPending = () => ({
  type: UPDATE_ROOM_DETAILS_PENDING,
});

export const updateRoomDetailsSuccess = () => ({
  type: UPDATE_ROOM_DETAILS_SUCCESS,
});

export const openCreateGroupModal = () => ({
  type: OPEN_CREATE_GROUP_MODAL,
});

export const closeCreateGroupModal = () => ({
  type: CLOSE_CREATE_GROUP_MODAL,
});

export const clearCreateGroupError = () => ({
  type: CLEAR_CREATE_GROUP_ERROR,
});

export const createGroupPending = () => ({
  type: CREATE_GROUP_PENDING,
});

export const createGroupSuccess = () => ({
  type: CREATE_GROUP_SUCCESS,
});

export const createGroupError = (errorMessage) => ({
  type: CREATE_GROUP_ERROR,
  payload: { errorMessage },
});

export const masterDeviceDetailsError = (errorMessage) => ({
  type: MASTER_DEVICE_DETAILS_ERROR,
  payload: { errorMessage },
});

export const setSelectedGroup = (selectedGroup) => ({
  type: SET_SELECTED_GROUP,
  payload: { selectedGroup },
});

export const updateSelectedDeviceSwitchList = (switchList) => ({
  type: UPDATE_SELECTED_DEVICE_SWITCHLIST,
  payload: { switchList },
});

export const updateSwitchDetails = (data) => ({
  type: UPDATE_SWITCH_DETAILS,
  payload: { data },
});

export const openUpdateGroupModal = () => ({
  type: OPEN_UPDATE_GROUP_MODAL,
});

export const closeUpdateGroupModal = () => ({
  type: CLOSE_UPDATE_GROUP_MODAL,
});

export const clearUpdateGroupError = () => ({
  type: CLEAR_UPDATE_GROUP_ERROR,
});

export const updateGroupPending = () => ({
  type: UPDATE_GROUP_PENDING,
});

export const updateGroupSuccess = () => ({
  type: UPDATE_GROUP_SUCCESS,
});

export const updateGroupError = (errorMessage) => ({
  type: UPDATE_GROUP_ERROR,
  payload: { errorMessage },
});

export const getDeviceDetails = (deviceId) => (dispatch) => {
  dispatch(getDeviceDetailsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.getDeviceDetails(accessToken, deviceId)
      .then((deviceDetails) => {
        dispatch(setDeviceDetails(deviceDetails));
        dispatch(getDeviceDetailsSuccess());
      })
      .catch((err) => {
        console.log("getDeviceDetails server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(deviceDetailsError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(deviceDetailsError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};
export const getSchedulerDetails = (id) => (dispatch) => {
  // dispatch(getDeviceDetailsPending());
  return getToken(dispatch).then((accessToken) => {
    return agent.Device.getSchedulerDetails(accessToken, id)
      .then((deviceDetails) => {
        return Promise.resolve(deviceDetails);
      })
      .catch((err) => {
        console.log("getDeviceDetails server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
          return Promise.reject(message);
        }
        else {
          const message = "Network error";
          dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
          return Promise.reject(message);
        }
      });
  });
};

export const updateDevice = (data) => (dispatch) => {
  data = {
    ...data,
    name: data.selected_product && data.selected_product.value,
  };
  const values = trimmedValues(data);
  dispatch(updateDevicePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.updateDevice(accessToken, values)
      .then((deviceId) => {
        dispatch(clearUpdateDeviceError());
        dispatch(updateDeviceSuccess());
        dispatch(closeEditDeviceModal());
        dispatch(getDeviceDetails(deviceId));
        dispatch(showSnackbarStatus("Device details updated successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateDeviceError(message));
        }
        console.log("Update device server error", err);
        // dispatch(updateDeviceError(null));
        // dispatch(closeEditDeviceModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const getMasterDeviceDetails = (masterDeviceId) => (dispatch) => {
  dispatch(getMasterDeviceDetailsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.getMasterDeviceDetails(accessToken, masterDeviceId)
      .then((masterDeviceDetails) => {
        dispatch(setMasterDeviceDetails(masterDeviceDetails));
        dispatch(getMasterDeviceDetailsSuccess());
      })
      .catch((err) => {
        console.log("masterDeviceDetails server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(masterDeviceDetailsError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(masterDeviceDetailsError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const updateMasterDevice = (data) => (dispatch) => {
  const masterDeviceData = {
    id: data.id,
    endCustomerId: data.selected_user && data.selected_user.value,
    friendlyName: data.friendlyName,
    subscriptionValidity: data.subscriptionValidity,
    boardSerialNumber: data.boardSerialNumber,
  };
  const values = trimmedValues(masterDeviceData)
  dispatch(updateMasterDevicePending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.updateMasterDevice(accessToken, values)
      .then((deviceId) => {
        dispatch(clearUpdateMasterDeviceError());
        dispatch(updateMasterDeviceSuccess());
        dispatch(closeEditMasterDeviceModal());
        dispatch(getMasterDeviceDetails(deviceId));
        dispatch(
          showSnackbarStatus("Master device details updated successfully")
        );
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateMasterDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateMasterDeviceError(message));
        }
        console.log("Update master device server error", err);
        // dispatch(updateMasterDeviceError(null));
        // dispatch(closeEditMasterDeviceModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const mapNewDevice = (MapGroup, masterDeviceId) => (dispatch) => {
  if (!MapGroup) {
    dispatch(mapNewDeviceError("Please fill required details."));
    return;
  }
  const separatedDeviceKeys = formatDeviceKeys(MapGroup.deviceKeys);
  const masterDeviceData = {
    // deviceKeys: MapGroup.deviceKeys.split(","),
    deviceKeys: separatedDeviceKeys,
    masterDeviceId: masterDeviceId,
    groupId: MapGroup.new_group && MapGroup.new_group.value,
  };
  const values = trimmedValues(masterDeviceData);
  dispatch(mapNewDevicePending());
  dispatch(clearMapNewDeviceError());
  getToken(dispatch).then((accessToken) => {
    agent.Device.mapNewDevice(accessToken, values)
      .then(() => {
        dispatch(mapNewDeviceSuccess());
        //   dispatch(clearForm());
        dispatch(closeMapNewDeviceModal());
        dispatch(getMasterDeviceDetails(masterDeviceId));
        dispatch(showSnackbarStatus("Devices added successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(mapNewDeviceError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(mapNewDeviceError(message));
        }
        console.log("Create master device / Devices added error", err);
        //   dispatch(clearForm());
        // dispatch(mapNewDeviceError(null));
        // dispatch(closeMapNewDeviceModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const updateRoomDetails = (deviceId, masterDeviceId, device) => (dispatch) => {
  // const deviceData = {
  //   roomName: device && device.roomName,
  //   roomNo: device && device.roomNo,
  //   deviceId: deviceId,
  //   masterDeviceId: masterDeviceId,
  //   groupId: selected_group && selected_group.value,
  //   switches: deviceDetails && deviceDetails.switchList,
  // };
  const deviceData = {
    masterDeviceId: masterDeviceId,
    deviceId: deviceId,
    groupId: device.selectedGroup && device.selectedGroup.value,
    ...device
  };
  const values = trimmedValues(deviceData)
  dispatch(updateRoomDetailsPending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.updateRoomDetails(accessToken, values)
      .then(() => {
        dispatch(clearUpdateRoomDetailsError());
        dispatch(updateRoomDetailsSuccess());
        //   dispatch(clearForm());
        dispatch(closeUpdateRoomDetailsModal());
        dispatch(getMasterDeviceDetails(masterDeviceId));
        dispatch(showSnackbarStatus("Room details updated successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateRoomDetailsError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateRoomDetailsError(message));
        }
        console.log("Room details updated server error", err);
        //   dispatch(clearForm());
        // dispatch(updateRoomDetailsError(null));
        // dispatch(closeUpdateRoomDetailsModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const removeMappedDevice = (masterDeviceId, deviceKey, swal) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Device.removeMappedDevice(accessToken, masterDeviceId, deviceKey)
      .then(() => {
        dispatch(getMasterDeviceDetails(masterDeviceId));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(showSnackbarStatus(message));
          return;
        }
        console.log("removeMappedDevice server error", err);
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const createGroup = (AddGroup, masterDeviceId) => (dispatch) => {

  if (!AddGroup) {
    dispatch(createGroupError("Please fill required details."));
    return;
  }

  const data = {
    groupName: AddGroup.name,
    groupNo: AddGroup.roomNo,
    masterDeviceId: masterDeviceId,
  };
  const values = trimmedValues(data)
  dispatch(createGroupPending());
  dispatch(clearCreateGroupError());
  getToken(dispatch).then((accessToken) => {
    agent.Device.createGroup(accessToken, values)
      .then((masterDeviceId) => {
        dispatch(createGroupSuccess());
        //   dispatch(clearForm());
        dispatch(closeCreateGroupModal());
        dispatch(getMasterDeviceDetails(masterDeviceId));
        dispatch(showSnackbarStatus("Group created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createGroupError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createGroupError(message));
        }
        console.log("Create group error", err);
        //   dispatch(clearForm());
        // dispatch(createGroupError(null));
        // dispatch(closeCreateGroupModal());
        dispatch(
          showSnackbarStatus("Something went wrong. Please try again later")
        );
      });
  });
};

export const updateGroup = (group, masterDeviceId) => (dispatch) => {
  const data = {
    groupName: group.groupName,
    groupNo: group.groupNo,
    id: group.groupId,
    masterDeviceId: masterDeviceId,
  };
  const values = trimmedValues(data);
  dispatch(updateGroupPending());
  getToken(dispatch).then((accessToken) => {
    agent.Device.updateGroup(accessToken, values)
      .then(() => {
        dispatch(clearUpdateGroupError());
        dispatch(updateGroupSuccess());
        dispatch(closeUpdateGroupModal());
        dispatch(getMasterDeviceDetails(masterDeviceId));
        dispatch(showSnackbarStatus("Group updated successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateGroupError(message));
          return;
        } else {
          const message = "Network error";
          dispatch(updateGroupError(message));
        }
        console.log("Update group error", err);
        // dispatch(updateGroupError(null));
        // dispatch(closeUpdateGroupModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

//--------------------------------MASTER DEVICE SWITCH DETAILS----------------------------------------------------------
export const setDeviceId = (deviceId) => ({
  type: SET_DEVICE_ID,
  payload: { deviceId }
});
export const openSwitchDetails = () => ({
  type: OPEN_SWITCH_DETAILS_MODAL,
});

export const closeSwitchDetails = () => ({
  type: CLOSE_SWITCH_DETAILS_MODAL,
});